import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { SEO } from './components/SEO';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-emerald-500 selection:text-white" data-id="element-0">
      <SEO data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Stats data-id="element-5" />
        <Services data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <Process data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <CTASection data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <WhatsAppButton data-id="element-13" />
    </div>;
}